export default "__VITE_ASSET__43aab2d1__"